import axios from 'axios'
import { LEADS_ENDPOINT } from 'cfgCommon/endpoints'

export async function reassignLeads(body) {
  return axios.post(`${LEADS_ENDPOINT}/reassignations`, body)
}
